import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OrderRequest } from './order.model';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  constructor(private http: HttpClient) {}

  purchaseOrder(orderRequest: OrderRequest) {
    return this.http.post(`/order/private/v1/orders`, orderRequest);
  }

  purchaseOrderV2(orderRequest: OrderRequest, orgId?: string) {
    const url = `/order/private/v2/orders`;
    return this.http.post('/order/private/v2/orders', orderRequest, {
      headers: orgId ? new HttpHeaders().set('x-user-org-uuid', orgId) : null
    });
  }
}
